import React, { useContext, useMemo } from "react";
import { UserContext } from "../amplify/authenticator-provider";

export const useGetOpportunityId = item => {
  const { user } = useContext(UserContext);
  const crmIntegrationType = user?.company?.crmIntegrationType;
  return useMemo(() => {
    if (!item) return null;

    const opportunityMap = {
      DS: () => (item.dsOpportunityEvents?.length ? item.dsOpportunityEvents[0].dsEventId : null),
      DT: () =>
        item.dtLeadOpportunities?.length ? item.dtLeadOpportunities[0].dtOpportunityId : null,
      SF: () =>
        item.sfLeadOpportunities?.length ? item.sfLeadOpportunities[0].sfOpportunityId : null,
      VIN: () => (item.vsLeadOpportunities?.length ? item.vsLeadOpportunities[0].vsLeadId : null),
      EL: () =>
        item.elLeadOpportunities?.length ? item.elLeadOpportunities[0].elOpportunityId : null,
      MF: () => (item.mfLeadOpportunities?.length ? item.mfLeadOpportunities[0].mfLeadId : null),
    };

    return opportunityMap[crmIntegrationType]?.() ?? item.id;
  }, [item, crmIntegrationType]);
};
